import { forwardRef, useCallback } from "react";
import { Box, FormControl, FormGroup, FormLabel } from "@mui/material";
import { CompanyType } from "$types";
import useCompany from "$hooks/useCompany";
import CompanyTypeCheckbox from "./CompanyTypeCheckbox";

const { AGENCY, CARRIER, CLIENT, CONTRIBUTOR, LOGISTICIAN, SUPPLIER } =
  CompanyType;

type Props = {
  clientDisabledMessage?: string;
  disabledCompanyTypes?: CompanyType[];
  disabledMessage?: string;
  label?: string;
  onChange: (newCompanyTypes: CompanyType[]) => void;
  value: CompanyType[];
};

const CompanyTypesCheckboxes = forwardRef<HTMLDivElement, Props>(
  (
    {
      clientDisabledMessage,
      disabledCompanyTypes,
      disabledMessage,
      label = "Type d'entreprise",
      onChange,
      value,
    }: Props,
    ref: any
  ) => {
    const { isClient } = useCompany();
    const renderCheckbox = useCallback(
      (companyType: CompanyType) => (
        <CompanyTypeCheckbox
          checked={value.includes(companyType)}
          companyType={companyType}
          disabled={disabledCompanyTypes?.includes(companyType)}
          disabledMessage={
            isClient(companyType) && clientDisabledMessage
              ? clientDisabledMessage
              : disabledMessage
          }
          onChange={onChange}
          value={value}
        />
      ),
      [
        clientDisabledMessage,
        disabledCompanyTypes,
        disabledMessage,
        isClient,
        onChange,
        value,
      ]
    );

    return (
      <FormControl component="fieldset" ref={ref}>
        <Box mb={1}>
          <FormLabel component="legend">{label}</FormLabel>
        </Box>
        <FormGroup>
          <Box
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Box display="flex" flexDirection="column">
              {renderCheckbox(CLIENT)}
              {renderCheckbox(CONTRIBUTOR)}
            </Box>
            <Box display="flex" flexDirection="column">
              {renderCheckbox(CARRIER)}
              {renderCheckbox(AGENCY)}
            </Box>
            <Box display="flex" flexDirection="column">
              {renderCheckbox(LOGISTICIAN)}
              {renderCheckbox(SUPPLIER)}
            </Box>
          </Box>
        </FormGroup>
      </FormControl>
    );
  }
);

export default CompanyTypesCheckboxes;
